import { createInstance } from 'app/localforage'
import set from 'lodash/set'
import get from 'lodash/get'
import { unwrap } from 'app/utils/unwrapReactive'

const KEY = 'state'

export const rootMutation = {
  LOCAL_INJECTION(state, [key, value]) {
    set(state, key, value)
  }
}

let hydrated = false

const storage = createInstance({
  name: 'vuex-store-hydrator'
})

export const hydrate = async (store) => {
  if (hydrated) return

  const data = await storage.getItem(KEY)

  if (data) {
    data.forEach((val) => {
      store.commit('LOCAL_INJECTION', val)
    })

    /* eslint-disable require-atomic-updates */
    hydrated = true
  }
}

export const setup = (store) => {
  const modules = store._modules.root._children
  const attrs = Object.keys(modules).reduce((acc, moduleName) => {
    const { recall = [] } = modules[moduleName]._rawModule
    recall.forEach((path) => {
      acc.push(`${moduleName}.${path}`)
    })
    return acc
  }, [])

  store.subscribe(async (mutation, state) => {
    const data = attrs.map((attr) => {
      return [attr, unwrap(get(state, attr))]
    })

    await storage.setItem(KEY, data)
  })
}
